// 由 EB view/admin/src/router/modules/product.js 自动转换
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';
const productRouter: RouteRecordRaw =
{
  path: `${roterPre}/product`,
  name: 'product',
  meta: {
    icon: 'dashboard',
    title: '商品管理'
  },
  alwaysShow: true,
  component: Layout,
  children: [
    {
      path: 'classify',
      name: 'ProductClassify',
      meta: {
        title: '商品分类',
        noCache: true
      },
      component: () => import('@/views/product/productClassify/index.vue')
    },
    {
      path: 'examine',
      name: 'ProductExamine',
      meta: {
        title: '商品管理',
        noCache: true
      },
      component: () => import('@/views/product/productExamine/index.vue')
    },
    {
      path: 'comment',
      name: 'ProductComment',
      meta: {
        title: '评论管理',
        noCache: true,
      },
      component: () => import('@/views/product/productComment/index.vue')
    },
    {
      path: 'label',
      name: 'ProductLabel',
      meta: {
        title: '商品标签',
        noCache: true
      },
      component: () => import('@/views/product/productLabel/index.vue')
    },
    {
      path: 'specs',
      name: 'ProductSpecs',
      meta: {
        title: '平台商品参数',
        noCache: true
      },
      component: () => import('@/views/product/specs/list.vue')
    },
    {
      path: 'merSpecs',
      name: 'MerProductSpecs',
      meta: {
        title: '店铺商品参数',
        noCache: true
      },
      component: () => import('@/views/product/specs/merList.vue')
    },
    {
      path: 'specs/create/:id?',
      name: 'ProductSpecsCreate',
      meta: {
        title: '添加参数模板',
        noCache: true,
        activeMenu: '/product/specs'
      },
      component: () => import('@/views/product/specs/create.vue')
    },
    {
      path: 'priceDescription',
      name: 'PriceDescription',
      meta: {
        title: '价格说明',
        noCache: true
      },
      component: () => import('@/views/product/priceDescription/index.vue')
    },
    {
      path: 'band',
      name: 'ProductBand',
      meta: {
        title: '品牌管理',
        noCache: true
      },
      component: () => import('@/views/product/band/index.vue'),
      children: [
        {
          path: 'brandList',
          name: 'BrandList',
          meta: {
            title: '品牌列表',
            noCache: true
          },
          component: () => import('@/views/product/band/bandList/index.vue')
        },
        {
          path: 'brandClassify',
          name: 'BrandClassify',
          meta: {
            title: '品牌分类',
            noCache: true
          },
          component: () => import('@/views/product/band/bandClassify/index.vue')
        }

      ]
    },
    {
      path: 'guarantee',
      name: 'ProductGuarantee',
      meta: {
        title: '保障服务',
        noCache: true
      },
      component: () => import('@/views/product/productGuarantee/index.vue')
    },

      {
          path: 'activityLabel',
          name: 'activityLabel',
          meta: {
              title: '活动标签',
              noCache: true
          },
          component: () => import('@/views/product/activityLabel/index.vue')
      }
  ]
}

export default productRouter;
